// src/routes/publisher_routes.tsx
import React, { ComponentType, FC } from 'react';
import PublisherLayoutComponent from '../Layout/PublisherLayout/PublisherLayoutComponent';

import Dashboard from '@/pages/Admin/Dashboard/Dashboard';
import Gamics from '@/pages/Admin/Gamics/Gamics';
import AdminCampaign from '@/pages/Admin/Campaign/Campaign';
import AuthMiddleware from '@/middleware/AuthMiddleware';
import User from '@/pages/Admin/User/User';
import Role from '@/pages/Admin/Role/Role';
import Ticket from '@/pages/Admin/Ticket/Ticket';
import PreviewGamic from '@/pages/Admin/Gamics/GamicPreview';
import PreviewCampaign from '@/pages/Admin/Campaign/CampaignPreview';
import { ShowTicket } from '@/pages/Admin/Ticket/ShowTicket';
import AddCampaign from '@/pages/Admin/Campaign/AddCampaign';
import PlayGamics from '@/pages/Play/PlayGamics';
import AccountSetting from '../pages/Admin/AccountSetting/AccountSetting';
import Categories from '@/pages/Admin/Categories/Categories';
// QA #7: admin Reports moderation queue.
import Reports from '@/pages/Admin/Reports/Reports';

const withPublisherLayout =
  <P extends object>(Page: ComponentType<P>): FC<P> =>
  (props) => (
    <PublisherLayoutComponent>
      {React.createElement(Page, props)}
    </PublisherLayoutComponent>
  );

const admin_routes: Record<string, ComponentType<any>> = {
  '/dashboard': withPublisherLayout(AuthMiddleware(Dashboard)),
  '/account-setting': withPublisherLayout(AuthMiddleware(AccountSetting)),

  '/play': (AuthMiddleware(PlayGamics)),

  
  // gamics
  '/gamics': withPublisherLayout(AuthMiddleware(Gamics, 'Gamic')),
  '/gamic/preview': withPublisherLayout(AuthMiddleware(PreviewGamic, 'Gamic')),

  // categories
  '/categories': withPublisherLayout(AuthMiddleware(Categories, 'Category')),
  // campaigns
  '/campaigns': withPublisherLayout(AuthMiddleware(AdminCampaign, 'Campaign')),
  '/campaign/preview': withPublisherLayout(
    AuthMiddleware(PreviewCampaign, 'Campaign'),
  ),
  '/add-campaign': withPublisherLayout(AuthMiddleware(AddCampaign, 'Campaign')),

  // user management
  '/users': withPublisherLayout(AuthMiddleware(User, 'User')),
  '/roles': withPublisherLayout(AuthMiddleware(Role, 'Role-Permission')),
  '/tickets': withPublisherLayout(AuthMiddleware(Ticket, 'Ticket')),
  '/show-ticket/:id': withPublisherLayout(AuthMiddleware(ShowTicket, 'Ticket')),

  // QA #7: moderation queue for gamic reports. AuthMiddleware gates by
  // role using the existing MODERATION_ROLES list.
  '/reports': withPublisherLayout(AuthMiddleware(Reports, 'Gamic')),
};

export default admin_routes;
